import React from 'react';
import { Link } from 'react-router-dom';
import { cities } from '../data/cities';
import { FaStar, FaMapMarkerAlt } from 'react-icons/fa';
import SearchBar from '../components/SearchBar';
import UnifiedStarBackground from '../components/UnifiedStarBackground';
import '../styles/Home.css';

const Home: React.FC = () => {
  return (
    <div className="home-container">
      <UnifiedStarBackground variant="primary" />
      <div className="hero-section">
        <h1>Discover Beautiful Destinations</h1>
        <p>Explore the most amazing places in India</p>
        <SearchBar />
      </div>
      
      <div className="cities-grid">
        {cities.map(city => (
          <Link to={`/city/${city.id}`} key={city.id} className="city-card">
            <div className="city-image-container">
              <img 
                src={city.image} 
                alt={city.name} 
                className="city-image" 
                loading="lazy"
              />
              <div className="city-rating">
                <FaStar className="star-icon" />
                <span>{city.rating}</span>
              </div>
            </div>
            <div className="city-info">
              <h2 className="city-name">
                <FaMapMarkerAlt className="location-icon" />
                {city.name}
              </h2>
              <p className="city-description">{city.description}</p>
              <div className="attractions-preview">
                <h3>Top Attractions:</h3>
                <ul>
                  {city.attractions.slice(0, 3).map((attraction, index) => (
                    <li key={index}>{attraction}</li>
                  ))}
                </ul>
              </div>
              <button className="explore-button">
                Explore More
              </button>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Home;